<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vSKpWd/tc-custom/9781504027953.jpg?1702556834097" alt="This image is the cover for the book Medusa's Child"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Medusa's Child
      </h1>
      <p class="bookDescription body article font2">
        <b>A pilot races through the sky to stop a nuclear catastrophe in this “compelling” thriller by the <i>New York Times–</i>bestselling author of <i>Pandora’s Clock</i> (<i>People</i>).</b><br/><br/> Vivian Henry hasn’t heard her ex-husband’s voice in three years, but it still fills her with fear. Dangerous and brilliant, Dr. Rogers Henry is calling because he’s dying. He offers Vivian a fortune in insurance money if she’ll carry out one final task for him: Take the Medusa device to Washington, DC. The Medusa is his life’s work—a thermonuclear bomb capable of knocking out all modern technology in the country—and he wants her to deliver it to the Pentagon before it falls into the wrong hands.<br/>  <br/> Cargo plane captain Scott McKay is miles above the ground when the Medusa begins to speak. A recording of Dr. Henry’s voice announces that the device is active and about to explode. With nowhere to land, Captain McKay must rely on his instincts and fly like he has never flown before to prevent a worldwide apocalypse.<br/>  <br/><i>Medusa’s Child</i> proves once again that John Nance is the “king of the modern-day aviation thriller” (<i>Publishers Weekly</i>).
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John J. Nance
      </h2>
      
      <p class="authorDescription body article">John J. Nance, aviation analyst for ABC News and a familiar face on Good Morning America, is the author of several bestselling novels including Fire Flight, Skyhook, Turbulence, and Orbit. Two of his novels, Pandora&#39;s Clock and Medusa&#39;s Child, have been made into highly successful television miniseries. A lieutenant colonel in the US&#160;Air Force Reserve, Nance is a decorated pilot veteran of Vietnam and Operations Desert Storm/Desert Shield. He lives in Washington State.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3fe27b02